// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var letterAnimationDuration = "500ms";
export var animateLetter = "AnimatedLetter-module--animate-letter--bKrBJ";
export var bulge = "AnimatedLetter-module--bulge--2oQEp";